import { Vector3 as s, Vector2 as P, Raycaster as m, Plane as w } from "three";
const g = ({
  event: n,
  pointer: e = new P(),
  camera: r,
  raycaster: c = new m(),
  plane: i = new w(),
  el: t
}) => {
  const { top: l, left: a } = t.getBoundingClientRect();
  e.x = (n.clientX - a) / t.clientWidth * 2 - 1, e.y = -((n.clientY - l) / t.clientHeight) * 2 + 1, c.setFromCamera(e, r);
  const o = new s();
  return c.ray.intersectPlane(i, o), o;
};
export {
  g as ProjectScreenToPlanePoint
};
//# sourceMappingURL=index24.js.map
